import { library } from '@fortawesome/fontawesome-svg-core';
import { faSearch } from '@fortawesome/free-solid-svg-icons';
import { useTranslator } from '@Localization';
import { observer } from 'mobx-react-lite';
import { ReactElement } from 'react';
import { SliderInput } from './SliderInput';

library.add(faSearch);

interface IZoomControlProps {
  onZoomLevelChange(zoomLevel: number): void;
  zoomValue: number;
  minZoomLevel: number;
  maxZoomLevel: number;
}

export const ZoomControl = observer((props: IZoomControlProps): ReactElement => {
  const { t } = useTranslator();

  const handleChangeEvent = (value: number): void => {
    props.onZoomLevelChange(value);
  };

  const renderValue = (value: number): ReactElement => <>{value}%</>;

  return (
    <SliderInput
      icon={faSearch}
      label={t('zoom')}
      min={props.minZoomLevel}
      max={props.maxZoomLevel}
      step={5}
      value={props.zoomValue}
      onChange={handleChangeEvent}
      renderValue={renderValue}
    />
  );
});
